import React from 'react';
import AffiliateLinkGenerator from './AffiliateLinkGenerator';

export default function ProductLinkModal({ affiliateCode, onClose }) {
  return (
    <div className="affiliate-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="affiliate-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="affiliate-product-link-title"
      >
        <div className="affiliate-modal-header">
          <h3 id="affiliate-product-link-title" className="affiliate-modal-title">
            Affiliate Links
          </h3>
          <button type="button" className="affiliate-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <p className="affiliate-modal-subtitle">
          Code: <strong>{affiliateCode}</strong>
        </p>

        <AffiliateLinkGenerator affiliateCode={affiliateCode} />
      </div>
    </div>
  );
}
